import { render, staticRenderFns } from "./SetClearRules.vue?vue&type=template&id=5b501a7d"
import script from "./SetClearRules.vue?vue&type=script&lang=js"
export * from "./SetClearRules.vue?vue&type=script&lang=js"
import style0 from "./SetClearRules.vue?vue&type=style&index=0&id=5b501a7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports